import { SET_RESOURCE_TOKEN } from "./types";

// Set logged in user
export const setResourceToken = (token) => {
  return {
    type: SET_RESOURCE_TOKEN,
    resource_token: token,
  };
};
